import React, { Fragment, lazy, Suspense, useEffect, useState } from 'react'
import { ThemeProvider } from 'react-jss'
import { theme } from '../ui/theme'

import ResponsiveContent from '../ui/Content/ResponsiveContent'
import Accordion from '../ui/Accordion'

const GenericPage = () => {
  const context = JSON.parse(
    atob(
      atob(data)
        .split('')
        .reverse()
        .join(''),
    )
      .split('')
      .reverse()
      .join(''),
  )

  return (
    <ThemeProvider theme={theme}>
      <ResponsiveContent {...context.ResponsiveContent} />
      <div style={{ width: '70%', margin: '0 auto', padding: '20px' }}>
        {!_.isEmpty(context.accordion)
          ? context.accordion.map((row, i) => (
              <Accordion title={row.title} key={i}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: row.body,
                  }}
                ></div>
              </Accordion>
            ))
          : ''}
      </div>
    </ThemeProvider>
  )
}

export default GenericPage
